import { render, staticRenderFns } from "./franchise-detail-form.vue?vue&type=template&id=db765cc8&scoped=true&"
import script from "./franchise-detail-form.vue?vue&type=script&lang=js&"
export * from "./franchise-detail-form.vue?vue&type=script&lang=js&"
import style0 from "./franchise-detail-form.vue?vue&type=style&index=0&id=db765cc8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db765cc8",
  null
  
)

export default component.exports